export default `

  <div class="modal__header">
    <div class="modal__name"></div>
  </div>
  
  <div class="modal__tabs-container">
    <div class="modal__tabs-selector">
      <div class="modal__tab-selector is-active" data-for="status">Status</div>
      <div class="modal__tab-selector" data-for="settings">Settings</div>
      <div class="modal__tab-selector" data-for="alerts">Alerts</div>
      <div class="modal__tab-selector" data-for="group">Group</div>
    </div>
    <div class="modal__tabs">
      <div class="modal__tab-content is-active" data-for="status">
        <div class="grid-x grid-margin-x">
          <div class="cell medium-12">
          
            <div class="modal__offline-status"></div>
          
            <div class="sensor-details__row">
              <div class="sensor-details__label">Temperature</div>
              <div class="sensor-details__value" data-for="temperature"></div>
            </div>
            <div class="sensor-details__row">
              <div class="sensor-details__label">Humidity</div>
              <div class="sensor-details__value" data-for="humidity"></div>
            </div>
            <div class="sensor-details__row">
              <div class="sensor-details__label">Battery</div>
              <div class="sensor-details__value" data-for="battery"></div>
            </div>
            
            <div class="sensor-details__row">
              <div class="sensor-details__label">Last Checkin</div>
              <div class="sensor-details__value" data-for="last-checkin"></div>
            </div>
            <div class="sensor-details__row">
              <div class="sensor-details__label">Next Checkin</div>
              <div class="sensor-details__value" data-for="next-checkin"></div>
            </div>
            
            <div class="sensor-details__row">
              <div class="sensor-details__label">Sensor ID</div>
              <div class="sensor-details__value" data-for="sensor-id"></div>
            </div>
            <div class="sensor-details__row">
              <div class="sensor-details__label">MAC Address</div>
              <div class="sensor-details__value" data-for="mac-address"></div>
            </div>

            <div class="sensor-details__separator"></div>
            
            <div class="sensor-details__row">
              <div class="sensor-details__label">Signal Strength</div>
              <div class="sensor-details__value" data-for="wifi-quality"></div>
            </div>
            
            <div class="sensor-details__row">
              <div class="sensor-details__label">Connection Time</div>
              <div class="sensor-details__value" data-for="connect-time"></div>
            </div>
            
          </div>
        </div>
      </div>
      <div class="modal__tab-content" data-for="settings">
        <form action="" method="post" data-for="settings">
          <h3>Sensor Settings</h3>
          
          <div class="sensor-modal--use-sensor-settings">
            <div class="settings-heading">Manual Sensor Settings</div>
            <div class="settings-label">Use different setttings for this sensor than the settings used by the group</div>
            <div class="switch medium">
              <input class="switch-input" type="checkbox" id="use_sensor_settings" name="use_sensor_settings" value="1" />
              <label class="switch-paddle" for="use_sensor_settings">
                <span class="switch-active">Yes</span>
                <span class="switch-inactive">No</span>
              </label>
            </div>
          </div>
          
          <div class="sensor-modal--sensor-settings">
            <div class="settings-row__label">Readings Check-in</div>
      <div class="settings-row__setting">
        <select class="settings-select" name="send_interval">
          <option value="3600">Every 60 minutes (recommended)</option>
          <option value="1800"}>Every 30 minutes</option>
          <option value="900"}>Every 15 minutes</option>
        </select>

        <div class="settings-label">Check-in more often when readings are above or below certain values</div>
        <div class="switch medium">
          <input class="switch-input" type="checkbox" id="use_alert_interval" name="use_alert_interval" value="1" />
          <label class="switch-paddle" for="use_alert_interval">
            <span class="switch-active">Yes</span>
            <span class="switch-inactive">No</span>
          </label>
        </div>
        
        <div class="sensor-modal--sensor-alert-settings settings-row__hidden-settings" data-for="use_alert_interval">

          <select name="alert_interval">
            <option value="3600">Every 60 minutes</option>
            <option value="1800">Every 30 minutes</option>
            <option value="900">Every 15 minutes</option>
            <option value="600">Every 10 minutes</option>
          </select>

          <div class="grid-x grid-margin-x">
            <div class="cell small-6 medium-3">
              <label>Below Temp</label>
              <input type="number" name="alert_temp_below" class="alert-number-select" value="" /> &deg;${window.getUserTempPref()}
            </div>
            <div class="cell small-6 medium-3">
              <label>Above Temp</label>
              <input type="number" name="alert_temp_above" class="alert-number-select" value="" /> &deg;${window.getUserTempPref()}
            </div>
            <div class="cell small-6 medium-3">
              <label>Below Humidity</label>
              <input type="number" name="alert_humidity_below" class="alert-number-select" value="" /> %
            </div>
            <div class="cell small-6 medium-3">
              <label>Above Humidity</label>
              <input type="number" name="alert_humidity_above" class="alert-number-select" value="" /> %
            </div>
          </div>
        </div>
                
        </div>
      </div>
        <div class="sensor-modal--calibration">
          
          <hr/>
        
          <div class="settings-heading">Sensor Data Calibration</div>
          <div class="switch medium">
            <input class="switch-input" type="checkbox" id="use_offset" name="use_offset" value="1" />
            <label class="switch-paddle" for="use_offset">
              <span class="switch-active">Yes</span>
              <span class="switch-inactive">No</span>
            </label>
          </div>
    
          <div class="settings-row__hidden-settings" data-for="use_offset">
  
            <div class="settings-label">Offset the sensor readings by these values</div>
            
            <div class="grid-x grid-margin-x">
              <div class="cell small-6 medium-3">
                <label>Temp Offset</label>
                <input type="number" name="temp_offset" class="alert-number-select" value="" /> &deg;${window.getUserTempPref()}
              </div>
              <div class="cell small-6 medium-3">
                <label>Humidity Offset</label>
                <input type="number" name="humidity_offset" class="alert-number-select" value="" /> %
              </div>
            </div>
          </div>
        
        </div>

      <div class="modal-save">
        <div class="modal-save__button">
        <button type="submit" class="button">Save Settings</button>
        </div>
        <div class="modal-save__message">
          <div class="form-modal-actions__message"></div>
        </div>
      </div>
    
    </form>
          </div>
          <div class="modal__tab-content group-modal__alerts" data-for="alerts">
          
            <form action="" method="post" class="" data-for="alerts">
              <div class="grid-x grid-margin-x">
                <div class="cell medium-6">
                  <h3>Alerts</h3>
                  <div class="settings-label">Select the alerts you want to use with this sensor:</div>
                  <select name="alerts" multiple></select>
                </div>
              </div>
              
              <div class="modal-save">
                <div class="modal-save__button">
                <button type="submit" class="button">Save Alerts</button>
                </div>
                <div class="modal-save__message">
                  <div class="form-modal-actions__message"></div>
                </div>
              </div>
            
            </form>

          </div>
          <div class="modal__tab-content group-modal__group" data-for="group">
          
            <form action="" method="post" class="" data-for="group">
              <div class="grid-x grid-margin-x">
                <div class="cell medium-6">
                  <h3>Sensor Group</h3>
                  <div class="settings-label">Assign this sensor to the following group:</div>
                  <select name="group"></select>
                </div>
              </div>
              
              <div class="modal-save">
                <div class="modal-save__button">
                <button type="submit" class="button">Change Group</button>
                </div>
                <div class="modal-save__message">
                  <div class="form-modal-actions__message"></div>
                </div>
              </div>
            
            </form>

          </div>
    </div>
  </div>
`;
